<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <InformationAlert
      title="Information"
      :description="alertConfig.description"
      :items="alertConfig.infoItems"
    />
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch"
      @showType="showType"
      :filters="filterConfig"
      @filter-search-input="handleFilterSearchInput"
      @filter-value-change="handleFilterValueChange"
      :noResetCall="true"
    />

    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :refresh-table="getData"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <span class="text-body-2 grey--text text--darken-1">
            <template v-if="selectedData.length > 0">
              {{ selectedData.length }} dari {{ totalData }} merchant dipilih
            </template>
          </span>
          <v-spacer />
          <v-btn
            color="primary"
            class="mb-2 rounded-pill elevation-0 mr-2"
            :disabled="loading || selectedData.length < 1"
            @click="openMappingDialog"
          >
            <v-icon left small>mdi-link-variant</v-icon>
            Mapping
          </v-btn>
          <v-btn
            outlined
            color="red"
            class="mb-2 rounded-pill mr-2"
            :disabled="loading || selectedData.length < 1"
            @click="openUnmappingDialog"
          >
            <v-icon left small>mdi-link-variant-off</v-icon>
            Unmapping
          </v-btn>
          <v-btn
            icon
            class="mb-2 rounded-pill"
            @click="getData"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon size="24" color="warning">mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`header.select_all`]>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="d-flex justify-center align-center select-all-wrapper"
            >
              <v-simple-checkbox
                color="white"
                dark
                :value="selectAllData"
                :indeterminate="selectAllIndeterminate"
                @input="onSelectAllToggle"
              />
            </div>
          </template>
          <span>Checklist Semua</span>
        </v-tooltip>
      </template>

      <template v-slot:select_all="{ item }">
        <div class="d-flex justify-center align-center select-row-wrapper">
          <v-simple-checkbox
            color="primary"
            :value="selectedData.includes(item.id)"
            @input="(checked) => onRowToggle(item.id, checked)"
          />
        </div>
      </template>

      <template v-slot:channel_provider_name="{ item }">
        {{ item.channel_provider_name || '—' }}
      </template>

      <template v-slot:aggregator_name="{ item }">
        {{ item.aggregator_name || '—' }}
      </template>

      <template v-slot:channel_provider_mapping_alias="{ item }">
        <v-chip
          v-if="Number(item.channel_provider_mapping_status) === 1"
          small
          color="green"
          text-color="white"
        >
          {{ item.channel_provider_mapping_alias || 'Sudah Dimapping' }}
        </v-chip>
        <v-chip
          v-else
          small
          color="orange"
          text-color="white"
        >
          {{ item.channel_provider_mapping_alias || 'Belum Dimapping' }}
        </v-chip>
      </template>
    </TableView>

    <v-dialog v-model="dialogProvider" max-width="560" persistent>
      <ChannelProviderPicker
        :selected-count="selectedData.length"
        :providers="channelProviderList"
        :loading="loadingChannelProvider"
        :initial-provider-id="chosenProviderId"
        @confirm="onProviderPicked"
        @cancel="onProviderCancel"
      />
    </v-dialog>

    <v-dialog v-model="dialogConfirm" max-width="640" persistent scrollable>
      <BulkMappingConfirm
        :merchants="selectedMerchantRows"
        :provider-name="selectedChannelProviderObj ? selectedChannelProviderObj.provider_name : ''"
        :loading="submitting"
        @confirm="onConfirmSubmit"
        @cancel="onConfirmCancel"
      />
    </v-dialog>

    <v-dialog v-model="dialogUnmapping" max-width="640" persistent scrollable>
      <BulkUnmappingConfirm
        :merchants="selectedMerchantRows"
        :loading="submittingUnmap"
        @confirm="onUnmappingSubmit"
        @cancel="onUnmappingCancel"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import mappingQrisTapMixin from '../../../components/merchant-tools/mapping-qristap/mappingQrisTapMixin';

export default {
  mixins: [mappingQrisTapMixin],
  components: {
    TableView: () => import('@components/@drontVue/components/Table/TableView.vue'),
    TableSearchFilter: () => import('@components/@drontVue/components/SearchFilter/TableSearchFilter.vue'),
    InformationAlert: () => import('@components/@drontVue/components/InformationAlert/index.vue'),
    ChannelProviderPicker: () => import('../../../components/merchant-tools/mapping-qristap/ChannelProviderPicker.vue'),
    BulkMappingConfirm: () => import('../../../components/merchant-tools/mapping-qristap/BulkMappingConfirm.vue'),
    BulkUnmappingConfirm: () => import('../../../components/merchant-tools/mapping-qristap/BulkUnmappingConfirm.vue'),
  },
};
</script>

<style scoped>
::v-deep td.select_all {
  text-align: center !important;
  vertical-align: middle !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
::v-deep th .select-all-wrapper,
::v-deep td .select-row-wrapper {
  width: 100%;
  min-height: 24px;
}
::v-deep .v-data-table-header th.text-start:has(.select-all-wrapper) {
  text-align: center !important;
}
</style>

